import type { Movie } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "m01",
    title: "长夜将明",
    type: "movie",
    genres: ["剧情", "悬疑"],
    region: "中国",
    year: 2024,
    rating: 8.7,
    duration: "128 分钟",
    director: "陈屿舟",
    cast: ["梁牧川", "周晚灵", "沈砚"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20in%20moody%20deep%20navy%20and%20warm%20amber%20tones%2C%20a%20lone%20figure%20walking%20through%20a%20rain-soaked%20night%20city%20street%2C%20dramatic%20rim%20lighting%20and%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20movie%20poster%20composition%2C%20high%20detail%2C%20atmospheric%20and%20mysterious%20mood&width=600&height=800&seq=yzs-cover-01&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rainy%20neon-lit%20city%20street%20at%20night%2C%20reflective%20wet%20asphalt%20with%20warm%20amber%20street%20lamps%2C%20a%20solitary%20silhouette%20in%20a%20long%20coat%2C%20moody%20atmospheric%20haze%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20dramatic%20and%20elegant%20composition%2C%20high%20detail&width=1280&height=720&seq=yzs-still-01&orientation=landscape",
    synopsis: "一名被停职的调查员在长夜里追踪一桩旧案，线索指向他早已放下的过往。随着真相层层剥开，他必须在正义与自我救赎之间做出选择。影片以冷峻的影像语言与克制的情感，讲述一个人在漫长黑夜中等待黎明降临的故事。",
    tags: ["犯罪", "都市", "真相"],
    popularity: 96,
    releaseDate: "2024-03-15",
  },
  {
    id: "m02",
    title: "星海之上",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2023,
    rating: 8.9,
    duration: "156 分钟",
    director: "Elena Marsh",
    cast: ["Caleb Holt", "Nadia Reyes", "Owen Pike"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20film%20poster%20depicting%20a%20vast%20starfield%20over%20a%20distant%20ringed%20planet%2C%20deep%20indigo%20and%20cyan%20cosmic%20palette%20with%20warm%20accent%20glow%2C%20sleek%20minimal%20typography%20space%2C%20lens%20flare%20and%20volumetric%20light%2C%20professional%20cinematic%20poster%20design%2C%20high%20detail%2C%20awe-inspiring%20and%20grand%20atmosphere&width=600&height=800&seq=yzs-cover-02&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Spacecraft%20drifting%20above%20a%20glowing%20ringed%20planet%20with%20distant%20stars%20and%20nebula%20clouds%2C%20deep%20indigo%20cosmic%20tones%20with%20warm%20rim%20light%2C%20volumetric%20glow%2C%20cinematic%20wide%20establishing%20shot%2C%20high%20detail%2C%20grand%20and%20awe-inspiring%20science%20fiction%20mood&width=1280&height=720&seq=yzs-still-02&orientation=landscape",
    synopsis: "一支国际探索队穿越虫洞抵达未知星域，寻找人类最后的宜居家园。当他们发现信号源背后隐藏的秘密时，整个团队不得不面对关于信任与牺牲的抉择。浩瀚星海之下，人类渺小却从未停止仰望。",
    tags: ["太空", "未来", "人性"],
    popularity: 94,
    releaseDate: "2023-11-02",
  },
  {
    id: "m03",
    title: "故乡的河",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "中国",
    year: 2022,
    rating: 8.3,
    duration: "115 分钟",
    director: "赵叙白",
    cast: ["柳知秋", "孟长宁", "苏婉"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20drama%20film%20poster%20with%20golden%20hour%20tones%20over%20a%20quiet%20river%20village%2C%20soft%20misty%20morning%20light%2C%20elderly%20figure%20and%20child%20by%20the%20water%2C%20muted%20earthy%20palette%20with%20warm%20orange%20highlights%2C%20subtle%20grain%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20tender%20and%20emotional%20mood&width=600&height=800&seq=yzs-cover-03&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Serene%20riverside%20village%20at%20golden%20hour%20with%20mist%20over%20calm%20water%2C%20silhouettes%20of%20an%20elder%20and%20a%20child%20walking%20along%20the%20bank%2C%20warm%20nostalgic%20tones%2C%20soft%20natural%20light%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20gentle%20and%20emotional%20atmosphere&width=1280&height=720&seq=yzs-still-03&orientation=landscape",
    synopsis: "离家多年的儿子回到故乡处理老宅，却在一件件旧物与邻居的闲谈里，重新认识了沉默寡言的父亲。河流依旧流淌，记忆里的误会与遗憾逐渐被时间冲淡。一部关于告别、归来与和解的温柔之作。",
    tags: ["亲情", "治愈", "乡土"],
    popularity: 82,
    releaseDate: "2022-06-18",
  },
  {
    id: "m04",
    title: "迷雾档案",
    type: "movie",
    genres: ["犯罪", "悬疑"],
    region: "韩国",
    year: 2024,
    rating: 8.5,
    duration: "132 分钟",
    director: "박지훈",
    cast: ["한서준", "임유나", "최도현"],
    cover: "https://readdy.ai/api/search-image?query=Ilford%20crime%20thriller%20movie%20poster%20with%20heavy%20fog%20and%20cold%20teal%20tones%2C%20blurred%20silhouette%20of%20a%20detective%20behind%20frosted%20glass%2C%20harsh%20geometric%20shadows%2C%20minimalist%20bold%20composition%2C%20subtle%20film%20grain%2C%20high%20contrast%2C%20professional%20poster%20design%2C%20tense%20and%20mysterious%20mood&width=600&height=800&seq=yzs-cover-04&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Dense%20foggy%20urban%20alley%20at%20dawn%20with%20cold%20teal%20lighting%20and%20harsh%20shadows%2C%20a%20detective%20silhouette%20under%20a%20flickering%20lamp%2C%20cinematic%20crime%20thriller%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20high%20detail%2C%20tense%20and%20mysterious%20mood&width=1280&height=720&seq=yzs-still-04&orientation=landscape",
    synopsis: "一叠被封存二十年的档案重新浮出水面，负责翻阅它的年轻检察官发现，所有线索都指向同一个人——自己的导师。在真伪难辨的迷雾中，他必须决定是守护真相还是守护信任。",
    tags: ["调查", "反转", "人性"],
    popularity: 89,
    releaseDate: "2024-05-24",
  },
  {
    id: "m05",
    title: "雨季来信",
    type: "movie",
    genres: ["爱情", "文艺"],
    region: "日本",
    year: 2021,
    rating: 8.1,
    duration: "108 分钟",
    director: "佐藤みなと",
    cast: ["高橋あおい", "中村りく", "小林ゆい"],
    cover: "https://readdy.ai/api/search-image?query=Soft%20romantic%20art%20house%20film%20poster%20with%20rainy%20season%20tones%2C%20pastel%20blue%20and%20warm%20cream%20palette%2C%20two%20figures%20under%20a%20translucent%20umbrella%2C%20delicate%20watercolor%20texture%2C%20airy%20minimal%20composition%20with%20generous%20negative%20space%2C%20gentle%20grain%2C%20high%20detail%2C%20tender%20and%20quiet%20mood&width=600&height=800&seq=yzs-cover-05&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Quiet%20Japanese%20street%20during%20the%20rainy%20season%20with%20soft%20pastel%20light%2C%20two%20figures%20sharing%20an%20umbrella%20and%20wet%20reflections%20on%20the%20pavement%2C%20delicate%20and%20airy%20tones%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20nostalgic%20and%20tender%20atmosphere&width=1280&height=720&seq=yzs-still-05&orientation=landscape",
    synopsis: "每年梅雨季，她都会收到一封没有署名的信。多年后她终于循着信上的地址找到了寄信人，却发现对方记忆中并没有她的名字。一段关于错过与重逢的细腻故事。",
    tags: ["纯爱", "治愈", "青春"],
    popularity: 76,
    releaseDate: "2021-07-09",
  },
  {
    id: "m06",
    title: "沙丘之外",
    type: "movie",
    genres: ["科幻", "史诗"],
    region: "美国",
    year: 2024,
    rating: 9.1,
    duration: "168 分钟",
    director: "Marcus Vale",
    cast: ["Dorian Reed", "Layla Kam", "Theo Vance"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20desert%20science%20fiction%20poster%20with%20vast%20sand%20dunes%20at%20dusk%2C%20burnt%20orange%20and%20deep%20shadow%20palette%20with%20a%20single%20luminous%20figure%2C%20sweeping%20wind-carved%20textures%2C%20dramatic%20skyscape%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20grand%20and%20mythic%20mood&width=600&height=800&seq=yzs-cover-06&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Endless%20desert%20dunes%20under%20a%20dramatic%20dusk%20sky%20with%20burnt%20orange%20and%20deep%20shadow%20tones%2C%20a%20lone%20cloaked%20figure%20crossing%20the%20sand%2C%20wind-carved%20textures%20and%20sun%20haze%2C%20cinematic%20epic%20wide%20shot%2C%20high%20detail%2C%20grand%20and%20mythic%20atmosphere&width=1280&height=720&seq=yzs-still-06&orientation=landscape",
    synopsis: "在资源耗尽的世界里，一名少年背负族群命运穿越无垠沙海。当他抵达传说中最后的绿洲时，等待他的却是比沙漠更残酷的真相。一部关于信念、权力与成长的史诗。",
    tags: ["沙海", "命运", "史诗"],
    popularity: 98,
    releaseDate: "2024-02-28",
  },
  {
    id: "m07",
    title: "山海谣",
    type: "movie",
    genres: ["奇幻", "古装"],
    region: "中国",
    year: 2023,
    rating: 8.4,
    duration: "140 分钟",
    director: "白落青",
    cast: ["江闻野", "沐清歌", "顾行舟"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20film%20poster%20inspired%20by%20ancient%20mythology%20with%20misty%20mountains%20and%20floating%20islands%2C%20jade%20green%20and%20deep%20ink%20blue%20palette%20with%20warm%20gold%20accents%2C%20flowing%20ink-wash%20texture%2C%20elegant%20oriental%20composition%2C%20high%20detail%2C%20ethereal%20and%20epic%20mood&width=600&height=800&seq=yzs-cover-07&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Misty%20ancient%20mountain%20landscape%20with%20floating%20islands%20and%20drifting%20clouds%2C%20jade%20green%20and%20deep%20ink%20blue%20tones%20with%20warm%20gold%20light%2C%20ink-wash%20atmosphere%2C%20cinematic%20epic%20wide%20shot%2C%20high%20detail%2C%20ethereal%20oriental%20fantasy%20mood&width=1280&height=720&seq=yzs-still-07&orientation=landscape",
    synopsis: "传说中消散千年的山海之灵重现人间，一个平凡的采药少年被卷入人与灵之间的旧怨。为了守护家园，他踏上寻找失落誓约的旅程。东方奇幻美学与宿命主题交织的视觉盛宴。",
    tags: ["东方奇幻", "宿命", "美学"],
    popularity: 88,
    releaseDate: "2023-08-11",
  },
  {
    id: "m08",
    title: "追风少年",
    type: "movie",
    genres: ["运动", "剧情"],
    region: "中国",
    year: 2022,
    rating: 7.9,
    duration: "118 分钟",
    director: "韩驰",
    cast: ["罗一鸣", "叶清和", "郑南"],
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20sports%20drama%20film%20poster%20with%20a%20young%20cyclist%20in%20motion%2C%20energetic%20warm%20orange%20and%20cool%20sky%20blue%20palette%2C%20motion%20blur%20streaks%2C%20sunrise%20backlight%2C%20bold%20youthful%20composition%2C%20high%20detail%2C%20inspiring%20and%20uplifting%20mood&width=600&height=800&seq=yzs-cover-08&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Young%20cyclists%20racing%20along%20an%20open%20road%20at%20sunrise%20with%20warm%20orange%20glow%20and%20cool%20morning%20sky%2C%20motion%20blur%20and%20speed%20streaks%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20energetic%20and%20uplifting%20atmosphere&width=1280&height=720&seq=yzs-still-08&orientation=landscape",
    synopsis: "被伤病击倒的少年车手回到小城，在破旧的训练场重新出发。他要面对的不只是赛道上的对手，还有那个始终不肯认输的自己。一部燃到骨子里的青春运动片。",
    tags: ["热血", "成长", "励志"],
    popularity: 74,
    releaseDate: "2022-09-30",
  },
  {
    id: "m09",
    title: "午夜列车",
    type: "movie",
    genres: ["惊悚", "悬疑"],
    region: "法国",
    year: 2023,
    rating: 8.0,
    duration: "102 分钟",
    director: "Julien Roche",
    cast: ["Camille Duv", "Louis Berg", "Ana Petit"],
    cover: "https://readdy.ai/api/search-image?query=Dark%20suspense%20thriller%20poster%20of%20a%20last%20train%20speeding%20through%20the%20night%2C%20cold%20charcoal%20and%20dim%20amber%20palette%2C%20long%20exposure%20light%20trails%2C%20unsettling%20negative%20space%2C%20minimal%20bold%20composition%2C%20high%20detail%2C%20tense%20and%20eerie%20mood&width=600&height=800&seq=yzs-cover-09&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Empty%20night%20train%20corridor%20with%20flickering%20amber%20lights%20and%20cold%20shadows%2C%20long%20exposure%20light%20trails%20outside%20the%20windows%2C%20unsettling%20atmosphere%2C%20cinematic%20thriller%20wide%20shot%2C%20high%20detail%2C%20tense%20and%20eerie%20mood&width=1280&height=720&seq=yzs-still-09&orientation=landscape",
    synopsis: "末班列车上，五名互不相识的乘客发现车门再也无法打开。随着列车驶向未知的终点，他们逐渐意识到，真正的危险并不在车厢之外。一场关于恐惧与真相的密闭博弈。",
    tags: ["密闭", "心理", "反转"],
    popularity: 80,
    releaseDate: "2023-10-13",
  },
  {
    id: "m10",
    title: "光年信笺",
    type: "movie",
    genres: ["爱情", "科幻"],
    region: "美国",
    year: 2024,
    rating: 8.6,
    duration: "134 分钟",
    director: "Sara Lindqvist",
    cast: ["Noah Grant", "Iris Chen", "Miles Dunne"],
    cover: "https://readdy.ai/api/search-image?query=Romantic%20science%20fiction%20poster%20blending%20deep%20space%20and%20handwritten%20letters%2C%20soft%20violet-blue%20and%20warm%20gold%20palette%2C%20floating%20paper%20light%20motes%2C%20dreamy%20bokeh%2C%20elegant%20composition%2C%20high%20detail%2C%20wistful%20and%20poetic%20mood&width=600&height=800&seq=yzs-cover-10&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Distant%20spacecraft%20window%20overlooking%20stars%20with%20soft%20violet-blue%20and%20warm%20gold%20tones%2C%20floating%20luminous%20particles%20and%20a%20handwritten%20letter%2C%20dreamy%20bokeh%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20wistful%20and%20poetic%20atmosphere&width=1280&height=720&seq=yzs-still-10&orientation=landscape",
    synopsis: "地球与火星之间通信延迟以分钟计，而一对恋人偏要跨越光年写下彼此的一生。当最后一封信抵达时，收信人已经老了。一部关于时间、距离与坚持的浪漫科幻。",
    tags: ["浪漫", "太空", "时间"],
    popularity: 91,
    releaseDate: "2024-06-07",
  },
  {
    id: "m11",
    title: "沉默的证人",
    type: "movie",
    genres: ["悬疑", "法庭"],
    region: "英国",
    year: 2021,
    rating: 8.2,
    duration: "126 分钟",
    director: "Harriet Cole",
    cast: ["Peter Hale", "Grace Onu", "Daniel Frost"],
    cover: "https://readdy.ai/api/search-image?query=Restrained%20courtroom%20drama%20poster%20with%20dark%20walnut%20and%20cream%20tones%2C%20a%20witness%20stand%20under%20a%20single%20beam%20of%20light%2C%20geometric%20shadows%2C%20minimal%20editorial%20composition%2C%20subtle%20grain%2C%20high%20detail%2C%20solemn%20and%20gripping%20mood&width=600&height=800&seq=yzs-cover-11&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Quiet%20courtroom%20interior%20with%20dark%20walnut%20wood%20and%20a%20single%20shaft%20of%20light%20across%20the%20witness%20stand%2C%20geometric%20shadows%2C%20cinematic%20drama%20wide%20shot%2C%20high%20detail%2C%20solemn%20and%20gripping%20atmosphere&width=1280&height=720&seq=yzs-still-11&orientation=landscape",
    synopsis: "一桩看似铁证如山的案件，因为一名拒不出庭的证人出现裂痕。年迈的辩护律师必须在有限时间里揭开沉默背后隐藏的恐惧。一部关于语言、真相与勇气的法庭剧。",
    tags: ["法庭", "真相", "人性"],
    popularity: 78,
    releaseDate: "2021-10-22",
  },
  {
    id: "m12",
    title: "喜马拉雅之巅",
    type: "movie",
    genres: ["纪录", "冒险"],
    region: "中国",
    year: 2023,
    rating: 9.0,
    duration: "98 分钟",
    director: "次仁多吉",
    cast: ["登山队", "夏尔巴向导"],
    cover: "https://readdy.ai/api/search-image?query=Sweeping%20documentary%20poster%20of%20snow-capped%20Himalayan%20peaks%20at%20first%20light%2C%20cool%20icy%20blue%20and%20warm%20sunrise%20gold%20palette%2C%20tiny%20climbers%20on%20a%20great%20ridge%2C%20vast%20negative%20space%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20sublime%20and%20awe-inspiring%20mood&width=600&height=800&seq=yzs-cover-12&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Vast%20Himalayan%20snow%20ridges%20at%20first%20light%20with%20climbers%20as%20tiny%20silhouettes%20on%20the%20crest%2C%20cool%20icy%20blue%20and%20warm%20sunrise%20gold%20tones%2C%20cinematic%20epic%20wide%20shot%2C%20high%20detail%2C%20sublime%20and%20awe-inspiring%20atmosphere&width=1280&height=720&seq=yzs-still-12&orientation=landscape",
    synopsis: "镜头跟随一支登山队从大本营出发，记录他们在极端环境中攀登的每一步。风雪、缺氧与恐惧之下，是人类对身体与意志极限的追问。真实影像带来的震撼直抵人心。",
    tags: ["纪录", "极限", "自然"],
    popularity: 85,
    releaseDate: "2023-04-14",
  },
  {
    id: "d01",
    title: "浮生若梦",
    type: "drama",
    genres: ["都市", "情感"],
    region: "中国",
    year: 2024,
    rating: 8.8,
    duration: "全 40 集",
    director: "林见夏",
    cast: ["许知微", "程越", "温亦柔"],
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20with%20warm%20amber%20and%20deep%20navy%20tones%2C%20two%20figures%20silhouetted%20against%20a%20city%20skyline%20at%20dusk%2C%20soft%20bokeh%20lights%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20refined%20and%20emotional%20mood&width=600&height=800&seq=yzs-cover-13&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Cinematic%20city%20skyline%20at%20dusk%20with%20warm%20amber%20lights%20and%20deep%20navy%20sky%2C%20two%20silhouetted%20figures%20on%20a%20rooftop%2C%20soft%20bokeh%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20refined%20and%20emotional%20atmosphere&width=1280&height=720&seq=yzs-still-13&orientation=landscape",
    synopsis: "三个在大城市打拼的年轻人在理想与现实之间反复妥协，又彼此扶持着走下去。职场、亲情与爱情交织成一段浮生，每个选择都映照着当下年轻人的模样。",
    tags: ["都市", "群像", "现实"],
    popularity: 93,
    releaseDate: "2024-01-19",
  },
  {
    id: "d02",
    title: "长安烟云",
    type: "drama",
    genres: ["古装", "权谋"],
    region: "中国",
    year: 2023,
    rating: 9.2,
    duration: "全 52 集",
    director: "沈砚山",
    cast: ["裴昭", "云清欢", "崔明远"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20power%20drama%20poster%20of%20an%20ancient%20walled%20city%20under%20drifting%20smoke%2C%20deep%20crimson%20and%20ink%20black%20palette%20with%20gold%20accents%2C%20elegant%20traditional%20motifs%2C%20grand%20composition%2C%20high%20detail%2C%20solemn%20and%20majestic%20mood&width=600&height=800&seq=yzs-cover-14&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20city%20at%20twilight%20with%20drifting%20smoke%20and%20warm%20lantern%20light%2C%20deep%20crimson%20and%20ink%20black%20tones%20with%20gold%20accents%2C%20cinematic%20epic%20wide%20shot%2C%20high%20detail%2C%20solemn%20and%20majestic%20atmosphere&width=1280&height=720&seq=yzs-still-14&orientation=landscape",
    synopsis: "乱世之中，一个出身寒微的少年一步步走入权力中心。朝堂之上的每一步都暗藏杀机，他必须在忠义与野心之间找到自己的道。恢弘格局与细腻人心兼具的古装权谋大剧。",
    tags: ["权谋", "古装", "群像"],
    popularity: 97,
    releaseDate: "2023-05-06",
  },
  {
    id: "d03",
    title: "寂静岭之屋",
    type: "drama",
    genres: ["惊悚", "悬疑"],
    region: "美国",
    year: 2022,
    rating: 8.0,
    duration: "全 10 集",
    director: "Ivy Clarkson",
    cast: ["Ronan Blake", "Tessa Frey", "Neil Ott"],
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20horror%20mystery%20series%20poster%20of%20an%20old%20house%20on%20a%20foggy%20hillside%2C%20cold%20desaturated%20teal%20and%20charcoal%20palette%2C%20single%20warm%20window%20light%2C%20stark%20minimal%20composition%2C%20high%20detail%2C%20eerie%20and%20haunting%20mood&width=600&height=800&seq=yzs-cover-15&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Old%20isolated%20house%20on%20a%20foggy%20hillside%20with%20one%20warm%20glowing%20window%2C%20cold%20desaturated%20teal%20and%20charcoal%20tones%2C%20cinematic%20mystery%20wide%20shot%2C%20high%20detail%2C%20eerie%20and%20haunting%20atmosphere&width=1280&height=720&seq=yzs-still-15&orientation=landscape",
    synopsis: "一家人搬进镇子边缘的老宅，怪事从第一夜就开始。当尘封的家族往事被揭开，他们才发现真正需要逃离的，是这栋房子记得的一切。氛围感拉满的悬疑惊悚剧。",
    tags: ["惊悚", "家族", "超自然"],
    popularity: 79,
    releaseDate: "2022-10-28",
  },
  {
    id: "d04",
    title: "白鹿原纪事",
    type: "drama",
    genres: ["年代", "家族"],
    region: "中国",
    year: 2021,
    rating: 8.6,
    duration: "全 46 集",
    director: "关中远",
    cast: ["白嘉言", "鹿子霖", "田小娥"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20period%20family%20saga%20poster%20of%20a%20wheat%20field%20and%20an%20old%20northern%20village%2C%20earthy%20ochre%20and%20deep%20umber%20palette%20with%20warm%20dusk%20light%2C%20textured%20grain%2C%20generous%20negative%20space%2C%20high%20detail%2C%20sweeping%20and%20nostalgic%20mood&width=600&height=800&seq=yzs-cover-16&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Vast%20wheat%20field%20beside%20an%20old%20northern%20Chinese%20village%20at%20dusk%2C%20earthy%20ochre%20and%20deep%20umber%20tones%20with%20warm%20light%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20sweeping%20and%20nostalgic%20atmosphere&width=1280&height=720&seq=yzs-still-16&orientation=landscape",
    synopsis: "以一座村庄为缩影，讲述两大家族三代人在时代变迁中的恩怨纠葛。土地、宗族与命运交错，写尽普通人在大时代里的坚韧与无奈。厚重而动人的年代群像。",
    tags: ["年代", "家族", "乡土"],
    popularity: 84,
    releaseDate: "2021-08-20",
  },
  {
    id: "d05",
    title: "心动信号",
    type: "drama",
    genres: ["青春", "爱情"],
    region: "韩国",
    year: 2024,
    rating: 7.8,
    duration: "全 16 集",
    director: "김소연",
    cast: ["이도윤", "한지아", "박선우"],
    cover: "https://readdy.ai/api/search-image?query=Bright%20youth%20romance%20series%20poster%20with%20pastel%20peach%20and%20sky%20blue%20palette%2C%20two%20students%20on%20a%20sunny%20campus%2C%20soft%20lens%20bloom%2C%20playful%20minimal%20composition%2C%20high%20detail%2C%20sweet%20and%20lively%20mood&width=600&height=800&seq=yzs-cover-17&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Sunny%20campus%20courtyard%20with%20two%20students%20walking%20together%2C%20pastel%20peach%20and%20sky%20blue%20tones%2C%20soft%20lens%20bloom%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20sweet%20and%20lively%20atmosphere&width=1280&height=720&seq=yzs-still-17&orientation=landscape",
    synopsis: "转学生与新同桌从互不顺眼到渐渐心动，校园里的每一次对视都像信号在闪烁。青春里的笨拙、勇敢与遗憾，都被写进了这段初恋故事。",
    tags: ["校园", "初恋", "治愈"],
    popularity: 81,
    releaseDate: "2024-04-02",
  },
  {
    id: "d06",
    title: "深海的约定",
    type: "drama",
    genres: ["剧情", "治愈"],
    region: "日本",
    year: 2023,
    rating: 8.9,
    duration: "全 12 集",
    director: "森川たける",
    cast: ["海野あかり", "白石ゆう", "藤堂かん"],
    cover: "https://readdy.ai/api/search-image?query=Gentle%20healing%20drama%20poster%20with%20soft%20aqua%20and%20warm%20sand%20tones%2C%20a%20small%20seaside%20town%20and%20calm%20ocean%2C%20delicate%20watercolor%20light%2C%20airy%20minimal%20composition%2C%20high%20detail%2C%20calm%20and%20comforting%20mood&width=600&height=800&seq=yzs-cover-18&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Quiet%20seaside%20town%20at%20soft%20morning%20light%20with%20calm%20aqua%20ocean%20and%20warm%20sand%20tones%2C%20delicate%20watercolor%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20calm%20and%20comforting%20atmosphere&width=1280&height=720&seq=yzs-still-18&orientation=landscape",
    synopsis: "失去方向的都市青年回到海边小镇，接手奶奶留下的小小食堂。一道道家常菜与来来往往的客人，慢慢治愈了彼此。关于告别、重启与温柔的治愈小品。",
    tags: ["治愈", "美食", "生活"],
    popularity: 87,
    releaseDate: "2023-07-15",
  },
  {
    id: "d07",
    title: "风起云涌",
    type: "drama",
    genres: ["谍战", "历史"],
    region: "中国",
    year: 2022,
    rating: 8.7,
    duration: "全 44 集",
    director: "程墨白",
    cast: ["陆行舟", "沈siluo", "关越"],
    cover: "https://readdy.ai/api/search-image?query=Period%20spy%20drama%20poster%20with%20rain-soaked%20old%20street%20and%20trench%20coats%2C%20muted%20olive%20and%20charcoal%20palette%20with%20warm%20lamp%20glow%2C%20smoky%20atmosphere%2C%20tense%20minimal%20composition%2C%20high%20detail%2C%20suspenseful%20and%20cinematic%20mood&width=600&height=800&seq=yzs-cover-19&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Rain-soaked%20old%20city%20street%20at%20night%20with%20trench-coated%20figures%20under%20warm%20lamp%20glow%2C%20muted%20olive%20and%20charcoal%20tones%2C%20cinematic%20espionage%20wide%20shot%2C%20high%20detail%2C%20suspenseful%20and%20cinematic%20atmosphere&width=1280&height=720&seq=yzs-still-19&orientation=landscape",
    synopsis: "战火纷飞的年代，他潜伏在最危险的地方，一步踏错便是万丈深渊。信仰与情义在暗流中交锋，每一个眼神都可能决定生死。紧张到屏息的谍战佳作。",
    tags: ["谍战", "信仰", "群像"],
    popularity: 86,
    releaseDate: "2022-03-11",
  },
  {
    id: "d08",
    title: "曼哈顿公寓",
    type: "drama",
    genres: ["都市", "群像"],
    region: "美国",
    year: 2023,
    rating: 8.3,
    duration: "全 22 集",
    director: "Nora Whitfield",
    cast: ["Ethan Cole", "Priya Nair", "Sam Turner"],
    cover: "https://readdy.ai/api/search-image?query=Contemporary%20ensemble%20city%20drama%20poster%20of%20a%20glass%20apartment%20tower%20at%20dusk%2C%20warm%20amber%20windows%20against%20cool%20slate%20sky%2C%20refined%20minimal%20composition%2C%20high%20detail%2C%20sophisticated%20and%20human%20mood&width=600&height=800&seq=yzs-cover-20&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Manhattan%20apartment%20building%20facade%20at%20dusk%20with%20warm%20amber%20windows%20against%20cool%20slate%20sky%2C%20cinematic%20urban%20wide%20shot%2C%20high%20detail%2C%20sophisticated%20and%20human%20atmosphere&width=1280&height=720&seq=yzs-still-20&orientation=landscape",
    synopsis: "同一栋公寓楼里，住着十几个彼此陌生却又息息相关的人。一场意外让他们的人生短暂交汇，也照见都市人各自的孤独与坚持。温暖又锋利的都市群像剧。",
    tags: ["群像", "都市", "治愈"],
    popularity: 80,
    releaseDate: "2023-09-08",
  },
  {
    id: "d09",
    title: "医者仁心",
    type: "drama",
    genres: ["医疗", "剧情"],
    region: "中国",
    year: 2024,
    rating: 8.5,
    duration: "全 38 集",
    director: "苏木青",
    cast: ["方若行", "叶知南", "周慕白"],
    cover: "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20with%20clean%20clinical%20whites%20and%20deep%20teal%20accents%2C%20a%20figure%20in%20scrubs%20under%20soft%20hospital%20light%2C%20minimal%20restrained%20composition%2C%20subtle%20grain%2C%20high%20detail%2C%20sincere%20and%20moving%20mood&width=600&height=800&seq=yzs-cover-21&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Bright%20hospital%20corridor%20with%20soft%20daylight%20and%20clean%20clinical%20whites%20plus%20deep%20teal%20accents%2C%20a%20quiet%20medical%20team%20walking%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20sincere%20and%20moving%20atmosphere&width=1280&height=720&seq=yzs-still-21&orientation=landscape",
    synopsis: "一名年轻主治医生在急诊室里经历一次次生死考验。技术之外，他学着去理解病人、同事与自己的局限。真实、克制又充满温度的职业群像剧。",
    tags: ["医疗", "职业", "温情"],
    popularity: 83,
    releaseDate: "2024-03-28",
  },
  {
    id: "d10",
    title: "时光邮局",
    type: "drama",
    genres: ["奇幻", "温情"],
    region: "中国",
    year: 2023,
    rating: 8.4,
    duration: "全 24 集",
    director: "沈知远",
    cast: ["童小满", "陆时安", "言溪"],
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20drama%20poster%20of%20a%20small%20old%20post%20office%20glowing%20at%20night%2C%20warm%20amber%20and%20deep%20indigo%20palette%2C%20floating%20letters%20in%20the%20air%2C%20cozy%20storybook%20composition%2C%20high%20detail%2C%20magical%20and%20warm%20mood&width=600&height=800&seq=yzs-cover-22&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Charming%20old%20post%20office%20interior%20glowing%20at%20night%20with%20warm%20amber%20light%20and%20deep%20indigo%20shadows%2C%20floating%20letters%20in%20the%20air%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20magical%20and%20warm%20atmosphere&width=1280&height=720&seq=yzs-still-22&orientation=landscape",
    synopsis: "小镇上有一间邮局，可以把信寄到任何一段时光。年轻的邮差替别人传递思念，也慢慢看清了自己心里的答案。奇想与温情交织的治愈故事。",
    tags: ["奇幻", "温情", "治愈"],
    popularity: 82,
    releaseDate: "2023-12-01",
  },
  {
    id: "d11",
    title: "北方有雪",
    type: "drama",
    genres: ["文艺", "剧情"],
    region: "中国",
    year: 2021,
    rating: 8.1,
    duration: "全 20 集",
    director: "关北",
    cast: ["沈冬", "何晚", "林砚"],
    cover: "https://readdy.ai/api/search-image?query=Literary%20drama%20poster%20of%20a%20snow-covered%20northern%20town%20under%20overcast%20light%2C%20cold%20white%20and%20muted%20blue-grey%20palette%20with%20one%20warm%20window%2C%20quiet%20minimal%20composition%2C%20high%20detail%2C%20lonely%20and%20poetic%20mood&width=600&height=800&seq=yzs-cover-23&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Snow-covered%20northern%20town%20street%20under%20soft%20overcast%20light%2C%20cold%20white%20and%20muted%20blue-grey%20tones%20with%20one%20warm%20window%2C%20cinematic%20wide%20shot%2C%20high%20detail%2C%20lonely%20and%20poetic%20atmosphere&width=1280&height=720&seq=yzs-still-23&orientation=landscape",
    synopsis: "北方小城的漫长冬天里，三个年轻人各自守着不愿说出口的心事。雪落无声，却在某个瞬间融化了人与人之间的隔阂。安静而有力量的文艺剧。",
    tags: ["文艺", "冬天", "成长"],
    popularity: 72,
    releaseDate: "2021-12-17",
  },
  {
    id: "d12",
    title: "破晓之城",
    type: "drama",
    genres: ["科幻", "悬疑"],
    region: "英国",
    year: 2024,
    rating: 8.8,
    duration: "全 8 集",
    director: "Alastair Finn",
    cast: ["Owen Marsh", "Freya Cole", "Idris Vane"],
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20mystery%20series%20poster%20of%20a%20rain-slicked%20neon%20city%20at%20dawn%2C%20deep%20teal%20and%20magenta-free%20cool%20palette%20with%20a%20single%20warm%20accent%2C%20sleek%20geometric%20composition%2C%20high%20detail%2C%20cold%20and%20thought-provoking%20mood&width=600&height=800&seq=yzs-cover-24&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=Futuristic%20city%20street%20at%20dawn%20with%20wet%20reflective%20surfaces%20and%20cool%20teal%20light%20plus%20a%20single%20warm%20accent%2C%20cinematic%20science%20fiction%20wide%20shot%2C%20high%20detail%2C%20cold%20and%20thought-provoking%20atmosphere&width=1280&height=720&seq=yzs-still-24&orientation=landscape",
    synopsis: "在一座永远比外界慢一步的城市里，人们的记忆可以被买卖。一名警探在调查失踪案时发现，自己也成了这座城的一个变量。冷峻而思辨的近未来悬疑剧。",
    tags: ["近未来", "记忆", "思辨"],
    popularity: 90,
    releaseDate: "2024-02-09",
  },
];

export const featuredIds = ["m06", "d02", "m02", "m01", "d12"];

export const regions = ["全部", "中国", "美国", "日本", "韩国", "英国", "法国"];

export const years = ["全部", "2024", "2023", "2022", "2021"];